import React, { useState } from "react";
import '../../css/documents/Main.css';

const Main = () => {
    const [filters, setFilters] = useState({
        documentNumber: "",
        title: "",
        type: "",
        discipline: "",
        status: "",
        revision: "",
        dateRange: ""
    });

    const [globalSearch, setGlobalSearch] = useState("");
    const [results, setResults] = useState([
        {
            file: "PDF",
            documentNumber: "PM210012-LTG531-ER2-00004",
            revision: "04",
            title: "PV PLANT - GENERAL CALCULATION REPORT AND",
            type: "Report",
            releasePurpose: "IFR - Issued for Review",
            status: "Code 4",
            discipline: "ELE - Electrical",
            revisionDate: "02/12/2023",
            dateModified: "11/12/2023",
            reviewSource: "WF-017411",
            organization: "LTG"
        }
    ]);

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters({ ...filters, [name]: value });
    };

    const handleGlobalSearch = (e) => {
        setGlobalSearch(e.target.value);
    };

    const handleSearch = () => {
        // Add search logic here (e.g., fetch filtered data from API)
        console.log("Filters:", filters);
    };

    // Filtered results based on global search
    const filteredResults = results.filter((result) =>
        Object.values(result).some((value) =>
            value.toString().toLowerCase().includes(globalSearch.toLowerCase())
        )
    );

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const handleStartDateChange = (e) => {
        setStartDate(e.target.value);
    };

    const handleEndDateChange = (e) => {
        setEndDate(e.target.value);
    };

    const handleClick = () => {
        alert('Clickable text clicked!');
    };

    const [rows, setRows] = useState(
        Array.from({ length: 1 }, (_, rowIndex) =>
            Array.from({ length: 24 }, (_, colIndex) => ({
                content: `Row ${rowIndex + 1}, Col ${colIndex + 1}`,
                isSelected: false, // Checkbox state
            }))
        )
    );

    // Handle "Select All" checkbox
    const handleSelectAll = (isChecked) => {
        setRows((prevRows) =>
            prevRows.map((row) =>
                row.map((cell, colIndex) =>
                    colIndex === 0 ? { ...cell, isSelected: isChecked } : cell
                )
            )
        );
    };

    // Handle individual row checkbox
    const handleRowCheckboxChange = (rowIndex, isChecked) => {
        setRows((prevRows) =>
            prevRows.map((row, rIndex) =>
                rIndex === rowIndex
                    ? row.map((cell, colIndex) =>
                        colIndex === 0 ? { ...cell, isSelected: isChecked } : cell
                    )
                    : row
            )
        );
    };

    // Check if all rows are selected
    const isAllSelected = rows.every((row) => row[0].isSelected);

    return (
        <div className="documents-main">
            <div className="top">
                <div className="global-search-bar">
                    <div className="search-bar-container">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#000000" /* Icon color */
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="search-icon"
                        >
                            <circle cx="11" cy="11" r="8"></circle>
                            <line x1="16" y1="16" x2="22" y2="22"></line>
                        </svg>
                        <input
                            type="text"
                            placeholder="Search across all document fields including Document Number"
                            value={globalSearch}
                            onChange={handleGlobalSearch}
                        />
                    </div>
                    <button className="search" onClick={handleSearch}>Search</button>
                    <button className="save-search" onClick={handleSearch}>Save Search As...</button>
                    <a href="#">Clear all filters</a>
                </div>
                <div className="search-options">
                    <label>
                        <input type="checkbox" id="fileContent" /> File Content
                    </label>
                    <label>
                        <input type="checkbox" id="showDocumentHistory" /> Show Document History
                    </label>
                </div>

                <div className="input-fields-container">
                    <div className="row">
                        <div className="input-field">
                            <label htmlFor="field1">Document No</label>
                            <input type="text" id="field1" defaultValue="PM210012-LTG531-ER2-0004" />
                        </div>
                        <div className="input-field">
                            <label htmlFor="field2">Title</label>
                            <input type="text" id="field2" />
                        </div>
                        <div className="dropdown-field1">
                            <label htmlFor="dropdown1">Type</label>
                            <select id="dropdown1" defaultValue="">
                                <option value="" disabled>Select values...</option>
                                <option value="option1">Option 1</option>
                                <option value="option2">Option 2</option>
                                <option value="option3">Option 3</option>
                                <option value="option4">Option 4</option>
                            </select>
                        </div>
                        <div className="input-field">
                            <label htmlFor="field4">Discipline</label>
                            <input type="text" id="field4" placeholder="Select values..." />
                        </div>
                        <div className="input-field">
                            <label htmlFor="field3">Status</label>
                            <input type="text" id="field3" placeholder="Select values..." />
                        </div>
                        <div className="input-field">
                            <label htmlFor="field4">Revision</label>
                            <input type="text" id="field4" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="input-field">
                            <label htmlFor="field1">Construction Work Package(CWP)</label>
                            <input type="text" id="field1" placeholder="Select values..." />
                        </div>
                        <div className="input-field">
                            <label htmlFor="field2">Work Package Area WPA</label>
                            <input type="text" id="field2" placeholder="Select values..." />
                        </div>
                        <div className="input-field">
                            <label htmlFor="field3">Equipment Tag</label>
                            <input type="text" id="field3" placeholder="Select values..." />
                        </div>
                        <div className="input-field">
                            <label htmlFor="field4">Originator</label>
                            <input type="text" id="field4" />
                        </div>
                        <div className="input-field">
                            <label htmlFor="field3">Client/3rd Party Document Number</label>
                            <input type="text" id="field3" />
                        </div>
                        <div className="input-field">
                            <label htmlFor="field4">VDR Codes & Descriptions</label>
                            <input type="text" id="field4" placeholder="Select values..." />
                        </div>
                    </div>
                    <div className="row">
                        <div className="input-field">
                            <label htmlFor="field1">Client/3rd Party Document Revision</label>
                            <input type="text" id="field1" />
                        </div>
                        <div className="input-field">
                            <label htmlFor="field2">Vendor or Internal Document Number</label>
                            <input type="text" id="field2" />
                        </div>
                        <div className="input-field">
                            <label htmlFor="field3">Vendor or Internal Document Revision</label>
                            <input type="text" id="field3" />
                        </div>
                        <div className="input-field">
                            <label htmlFor="field4">Commissioning System ID</label>
                            <input type="text" id="field4" placeholder="Select values..." />
                        </div>
                        <div className="input-field">
                            <label htmlFor="field3">Release Purpose</label>
                            <input type="text" id="field3" placeholder="Select values..." />
                        </div>
                        <div className="input-field">
                            <label htmlFor="field4">Organization Code</label>
                            <input type="text" id="field4" placeholder="Select values..." />
                        </div>
                    </div>
                    <div className="row">
                        <div className="input-field">
                            <label htmlFor="field1">Unit Code</label>
                            <input type="text" id="field1" placeholder="Select values..." />
                        </div>
                        <div className="input-field">
                            <label htmlFor="field2">Element</label>
                            <input type="text" id="field2" placeholder="Select values..." />
                        </div>
                        <div className="input-field">
                            <label htmlFor="field3">Document Class</label>
                            <input type="text" id="field3" placeholder="Select values..." />
                        </div>
                        <div className="input-field">
                            <label htmlFor="field4">Review Status</label>
                            <input type="text" id="field4" placeholder="Select values..." />
                        </div>
                        <div className="input-field">
                            <label htmlFor="field3">OT Integration System</label>
                            <input type="text" id="field3" placeholder="Select values..." />
                        </div>
                        <div className="input-field">
                            <label htmlFor="field3">OT Integration System</label>
                            <input type="text" id="field3" placeholder="Select values..." />
                        </div>
                    </div>

                    {/* <div className="row">
                        <div className="input-field">
                            <label htmlFor="startDate">Date Type</label>
                            <input
                                type="date"
                                id="startDate"
                                value={startDate}
                                onChange={handleStartDateChange}
                            />
                        </div>
                        <div className="input-field">
                            <label htmlFor="endDate">Date Range</label>
                            <input
                                type="date"
                                id="endDate"
                                value={endDate}
                                onChange={handleEndDateChange}
                                min={startDate}
                            />
                        </div>

                    </div> */}

                    <div className="row">
                        <div className="more-filters">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-arrow-right"
                                viewBox="0 0 16 16">
                                <path d="M10.854 7.646a.5.5 0 0 0 0-.708L7.207 3.5a.5.5 0 1 0-.707.707L9.293 6H1.5a.5.5 0 0 0 0 1h7.793l-2.793 2.793a.5.5 0 1 0 .707.707l3.646-3.646z" />
                            </svg>
                            <label htmlFor="startDate">More Filters(0)</label>
                        </div>
                    </div>
                </div>
            </div>
            <hr />

            <div className="bottom">
                <div className="options">
                    <div className="left">
                        <button className="arrow-button">
                            Transmit
                            <span>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="14"
                                    fill="currentColor"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M1.646 5.854a.5.5 0 0 1 .708 0L8 11.207l5.646-5.353a.5.5 0 1 1 .708.708l-6 5.666a.5.5 0 0 1-.708 0l-6-5.666a.5.5 0 0 1 0-.708z"
                                    />
                                </svg>
                            </span>
                        </button>
                        <button className="arrow-button">
                            Tools
                            <span>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="14"
                                    fill="currentColor"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M1.646 5.854a.5.5 0 0 1 .708 0L8 11.207l5.646-5.353a.5.5 0 1 1 .708.708l-6 5.666a.5.5 0 0 1-.708 0l-6-5.666a.5.5 0 0 1 0-.708z"
                                    />
                                </svg>
                            </span>
                        </button>
                        <button className="arrow-button">
                            Reports
                            <span>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="14"
                                    fill="currentColor"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M1.646 5.854a.5.5 0 0 1 .708 0L8 11.207l5.646-5.353a.5.5 0 1 1 .708.708l-6 5.666a.5.5 0 0 1-.708 0l-6-5.666a.5.5 0 0 1 0-.708z"
                                    />
                                </svg>
                            </span>
                        </button>
                    </div>
                    <div className="right">
                        <button className="arrow-button">
                            Add/Remove Columns
                            <span>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="14"
                                    fill="currentColor"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M1.646 5.854a.5.5 0 0 1 .708 0L8 11.207l5.646-5.353a.5.5 0 1 1 .708.708l-6 5.666a.5.5 0 0 1-.708 0l-6-5.666a.5.5 0 0 1 0-.708z"
                                    />
                                </svg>
                            </span>
                        </button>
                    </div>

                </div>
                <div className="labels">
                    <label>1 results (0 selected)</label>
                    <a href="#" onClick={(e) => {
                        e.preventDefault();  // Prevent default link behavior
                        handleSelectAll();   // Toggle Select All
                    }}>Select All</a>
                </div>
                <div className="table-wrapper">
                    {/* Fixed Columns */}
                    <div className="fixed-columns">
                        <table>
                            <thead>
                                <tr>
                                    <th>
                                        <input
                                            type="checkbox"
                                            checked={isAllSelected}
                                            onChange={(e) => handleSelectAll(e.target.checked)}
                                        />
                                    </th>
                                    <th>File</th>
                                    <th>Document No</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((row, rowIndex) => (
                                    <tr key={rowIndex}>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={row[0].isSelected}
                                                onChange={(e) =>
                                                    handleRowCheckboxChange(rowIndex, e.target.checked)
                                                }
                                            />
                                        </td>
                                        <td style={{ display: 'flex', alignItems: 'center' }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#ff0000" class="bi bi-file-earmark-pdf" viewBox="0 0 16 16" style={{ marginRight: '10px', cursor: 'pointer' }}>
                                                <path d="M9 0H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V5l-4-5zM5 1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4H5V1zM4 3h8v9a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3z" />
                                            </svg>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#ccc" class="bi bi-pencil-square" viewBox="0 0 16 16" style={{ cursor: 'pointer' }}>
                                                <path d="M12.146 0l3.708 3.708a1 1 0 0 1 0 1.414l-9.737 9.737a1 1 0 0 1-.433.234l-2.29.573a1 1 0 0 1-1.246-1.246l.573-2.29a1 1 0 0 1 .234-.433L12.146 0zM11.207 2l2.5 2.5L4.5 11.5l-2 1 .573-2.29a1 1 0 0 1 .234-.433L11.207 2z" />
                                            </svg>
                                        </td>
                                        <td style={{
                                            maxWidth: '200px', wordWrap: 'break-word',
                                            whiteSpace: 'normal',
                                            overflow: 'hidden'
                                        }}>PM210012.11G531.FR2.03304</td>

                                        {/* <td style={{
                                            maxWidth: '200px', wordWrap: 'break-word',
                                            whiteSpace: 'normal',
                                            overflow: 'hidden'
                                        }}>PM210012.11G531.FR2.03304</td> */}

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Scrollable Columns */}
                    <div className="scrollable-columns">
                        <table>
                            <thead>
                                <tr>
                                    <th>Revision</th>
                                    <th>Title</th>
                                    <th>Type</th>
                                    <th>Release Purpose</th>
                                    <th>Status</th>
                                    <th>Discipline</th>
                                    <th>Review Status</th>
                                    <th>Revision Date</th>
                                    <th>Date Modified</th>
                                    <th>Review Source</th>
                                    <th>Organization Code</th>
                                    <th>Review Source</th>
                                    <th>Organization Code</th>
                                    <th>Review Source</th>
                                    <th>Organization Code</th>
                                    <th>Review Source</th>
                                    <th>Organization Code</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ borderLeft: '1px solid #ccc' }}>04</td>
                                    <td  style={{
                                            minWidth: '300px'
                                        }}><a href="#">PV-PLANT - GENERAL - PVSYS CALCULATION  REPORT AND</a></td>
                                    <td>Report</td>
                                    <td>IFR - Issued for Rev...</td>
                                    <td>Code 4</td>
                                    <td>ELE - Electrical</td>
                                    <td><a href="#">CODE 4 - No Comments</a></td>
                                    <td>02/12/2023</td>
                                    <td>11/12/2023</td>
                                    <td><a href="#">WF-017411</a></td>
                                    <td>LTG</td>
                                    <td><a href="#">WF-017411</a></td>
                                    <td>LTG</td>
                                    <td><a href="#">WF-017411</a></td>
                                    <td>LTG</td>
                                    <td><a href="#">WF-017411</a></td>
                                    <td>LTG</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Main;
